"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        overflow: 'hidden',
        backgroundColor: theme.indigo3,
        transform: 'translateZ(0)',
        borderRadius: 2,
        maxHeight: 'inherit',
        boxShadow: `2px 3px 10px 0 rgba(0,0,0,0.1)`
    },
    options: {
        overflow: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        backgroundColor: 'inherit',
        maxHeight: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        position: 'relative',
        zIndex: 0
    }
});
//# sourceMappingURL=select.menu.style.js.map